import { render, staticRenderFns } from "./MessageIndex.vue?vue&type=template&id=01eba1a6&scoped=true"
import script from "./MessageIndex.vue?vue&type=script&lang=js"
export * from "./MessageIndex.vue?vue&type=script&lang=js"
import style0 from "./MessageIndex.vue?vue&type=style&index=0&id=01eba1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eba1a6",
  null
  
)

export default component.exports